export interface ErrorExistingPatient {
    id: string;
    nom: string;
    prenom: string;
    cpNaissance?: string;
    mail?: string;
    telephone?: string;
}

export function isErrorExistingPatientInterface(obj: any): boolean {
    if (
        obj.id && obj.id !== ''
        && obj.nom && obj.nom !== ''
        && obj.prenom && obj.prenom !== ''
    ) {
        return true;
    }
    return false;
};
